import { useEffect } from "react";
import { useLenis } from "lenis/react";

// Elements with this class get their width reduced by the scrollbar width while
// scrolling is locked, so fixed elements (e.g. the navbar) don't shift.
const SCROLLBAR_COMPENSATION_CLASS = "scrollbar-width";

const setCompensatedWidth = (value: string) => {
  const elements = document.getElementsByClassName(
    SCROLLBAR_COMPENSATION_CLASS,
  ) as HTMLCollectionOf<HTMLElement>;
  for (const element of Array.from(elements)) {
    element.style.setProperty("width", value);
  }
};

/**
 * Stops lenis scrolling while `isLocked` is true and compensates the
 * disappearing scrollbar to prevent a horizontal layout shift.
 */
const useScrollLock = (isLocked: boolean) => {
  const lenis = useLenis();

  useEffect(() => {
    if (!isLocked) return;

    const htmlTag = document.documentElement;
    const scrollBarWidth = window.innerWidth - htmlTag.clientWidth;
    if (scrollBarWidth !== 0) {
      setCompensatedWidth(`calc(100% - ${scrollBarWidth}px)`);
      htmlTag.style.marginRight = `${scrollBarWidth}px`;
    }
    lenis?.stop();

    return () => {
      setCompensatedWidth("100%");
      htmlTag.style.marginRight = "unset";
      lenis?.start();
    };
  }, [isLocked, lenis]);
};

export default useScrollLock;
